module.exports = __webpack_public_path__ + "static/img/zhongxin.aa4d13d8.png";